import { Box } from "@mui/material";
import React from "react";

const OptionButton = ({ onClick, selected, text }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        padding: "0.25rem 0.75rem",
        fontSize: "0.875rem",
        borderRadius: "0.375rem",
        whiteSpace: "nowrap",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        border: "none",
        cursor: "pointer",
        ...(!selected
          ? {
              color: "#9CA3AF",
              backgroundColor: "transparent",
            }
          : {
              backgroundColor: "#374151",
              color: "#FFFFFF",
            }),
        fontWeight: 600,
      }}
    >
      {text}
    </Box>
  );
};

export default OptionButton;
